<script setup lang="ts">
  import sparkleAccentUrl from '@/assets/icons/floating-ai-sparkle-accent.svg'
  import sparkleMainUrl from '@/assets/icons/floating-ai-sparkle-main.svg'
  import { useTranslation } from '@/composables/useTranslation'
  import { cn } from '@/lib/utils'
  import { useUnifiedChatStore } from '@/store/app/unifiedChat'

  const unifiedChat = useUnifiedChatStore()

  const { t } = useTranslation({
    en: {
      openAssistant: 'Open AI assistant'
    },
    de: {
      openAssistant: 'KI-Assistent öffnen'
    }
  })

  const onClick = () => {
    unifiedChat.toggleSidePanel()
  }
</script>

<template>
  <!--
    The button stays at a static ``right-6`` because :file:`assets/index.css` keeps the
    vertical scrollbar anchored to ``<html>`` on classic-scrollbar OSes — radix-vue's
    modal scroll-lock can no longer remove the scrollbar, so the layout viewport width
    never changes when a Dialog opens and we don't need any ``var(--scrollbar-width)``
    compensation here.
  -->
  <button
    type="button"
    :class="
      cn(
        'fixed bottom-6 right-6 z-40 flex size-16 items-center justify-center rounded-full bg-primary',
        'shadow-[0_8px_24px_-4px_rgba(15,23,42,0.12),0_4px_8px_-2px_rgba(15,23,42,0.08)]',
        '[-webkit-tap-highlight-color:transparent]',
        'outline-none focus-visible:outline-none',
        'hover:bg-primary active:bg-primary'
      )
    "
    :aria-label="t('openAssistant')"
    data-cy="floating-ai-button"
    @click="onClick"
  >
    <span
      class="pointer-events-none relative size-[33px] shrink-0"
      aria-hidden="true"
    >
      <span class="absolute bottom-[1.27px] left-[-0.07px] size-[29.867px] overflow-hidden">
        <img
          :src="sparkleMainUrl"
          alt=""
          class="block size-full max-w-none"
          width="30"
          height="30"
          decoding="async"
        />
      </span>
      <span class="absolute left-[23.33px] top-[0.93px] size-[7.467px]">
        <img
          :src="sparkleAccentUrl"
          alt=""
          class="block size-full max-w-none"
          width="8"
          height="8"
          decoding="async"
        />
      </span>
    </span>
  </button>
</template>
